import { SankeyLink } from '../types/sankey';

export const RTC1: SankeyLink[] = [
    {
        source: 101,
        target: 15,
        value: 1,
        valueid: ['repb', 'targetbb'],
        paperName: 'CGK21',
        process: 'CGK21_3',
        id: 'CGK21-4',
        cluster: 'rtc1',
        imgUrl: 'Q201xEJ.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 15, target: 32, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-14', cluster: 'rtc1', imgUrl: 'Q201xEJ.jpg', color: 'intOneLinkColor' },
    { source: 32, target: 59, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-22', cluster: 'rtc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { source: 59, target: 88, value: 1, valueid: ['repeb', 'targetbb'], paperName: 'CGK21', process: 'CGK21_3', id: 'CGK21-45', cluster: 'rtc1', imgUrl: 'Q201xEJ.jpg', color: 'repVisTechColor' },
    { source: 116, target: 3, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-0', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    { source: 116, target: 3, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-1', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    {
        source: 116,
        target: 23,
        value: 1,
        valueid: 'repa',
        paperName: 'LJC18',
        process: 'LJC18_10',
        id: 'LJC18-9',
        cluster: 'rtc1',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 3, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-14', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 3, target: 49, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-15', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 23, target: 49, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-18', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 62, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-25', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-26', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 49, target: 63, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-28', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFiveLight2LinkColor' },
    { source: 62, target: 88, value: 1, valueid: 'reph', paperName: 'LJC18', process: 'LJC18_4', id: 'LJC18-32', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 63, target: 88, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_1', id: 'LJC18-33', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 63, target: 88, value: 1, valueid: 'repa', paperName: 'LJC18', process: 'LJC18_10', id: 'LJC18-34', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    {
        source: 117,
        target: 7,
        value: 1,
        valueid: ['targetca', 'targetab'],
        paperName: 'LLN14',
        process: 'LLN14_1',
        id: 'LLN14-0',
        cluster: 'rtc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 7,
        target: 34,
        value: 1,
        valueid: ['targetca', 'targetab'],
        paperName: 'LLN14',
        process: 'LLN14_1',
        id: 'LLN14-6',
        cluster: 'rtc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 34,
        target: 55,
        value: 1,
        valueid: ['targetca', 'targetab'],
        paperName: 'LLN14',
        process: 'LLN14_1',
        id: 'LLN14-7',
        cluster: 'rtc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'intOneLightLinkColor',
    },
    { source: 55, target: 88, value: 1, valueid: ['targetca', 'targetab'], paperName: 'LLN14', process: 'LLN14_1', id: 'LLN14-10', cluster: 'rtc1', imgUrl: 'xWQU5gc.jpg', color: 'repVisTechColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_2',
        id: 'XWS16-3',
        cluster: 'rtc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-10', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-20', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 55, target: 88, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_2', id: 'XWS16-34', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    {
        source: 139,
        target: 11,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RSRY12',
        process: 'RSRY12_2',
        id: 'RSRY12-1',
        cluster: 'rtc1',
        imgUrl: 'ivVW2HN.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 46, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-5', cluster: 'rtc1', imgUrl: 'ivVW2HN.png', color: 'intFiveLinkColor' },
    { source: 46, target: 70, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-10', cluster: 'rtc1', imgUrl: 'ivVW2HN.png', color: 'intFiveLinkColor' },
    { source: 70, target: 88, value: 1, valueid: 'targetbb', paperName: 'RSRY12', process: 'RSRY12_2', id: 'RSRY12-16', cluster: 'rtc1', imgUrl: 'ivVW2HN.png', color: 'repVisTechColor' },
    {
        source: 140,
        target: 15,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-7',
        cluster: 'rtc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 15,
        target: 49,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-8',
        cluster: 'rtc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 59,
        value: 1,
        valueid: ['repea', ' targetca'],
        paperName: 'FAKM15',
        process: 'FAKM15_2',
        id: 'FAKM15-9',
        cluster: 'rtc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 59, target: 88, value: 1, valueid: ['repea', ' targetca'], paperName: 'FAKM15', process: 'FAKM15_2', id: 'FAKM15-12', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'repVisTechColor' },
    {
        source: 140,
        target: 24,
        value: 1,
        valueid: 'targetca',
        paperName: 'FAKM15',
        process: 'FAKM15_3',
        id: 'FAKM15-13',
        cluster: 'rtc1',
        imgUrl: 'u2sWSNe.jpg',
        color: 'targetLinkFourColor',
        status: 'selected',
    },
    { source: 24, target: 46, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-14', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLinkColor' },
    { source: 24, target: 49, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-15', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLight2LinkColor' },
    { source: 46, target: 75, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-16', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLinkColor' },
    { source: 49, target: 75, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-17', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'intFiveLight2LinkColor' },
    { source: 75, target: 88, value: 1, valueid: 'targetca', paperName: 'FAKM15', process: 'FAKM15_3', id: 'FAKM15-18', cluster: 'rtc1', imgUrl: 'u2sWSNe.jpg', color: 'repVisTechColor' },
    {
        source: 142,
        target: 11,
        value: 1,
        valueid: 'reph',
        paperName: 'CSL16',
        process: 'CSL16_2',
        id: 'CSL16-1',
        cluster: 'rtc1',
        imgUrl: 'mt871Nx.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-13', cluster: 'rtc1', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 39, target: 62, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-14', cluster: 'rtc1', imgUrl: 'mt871Nx.png', color: 'intTwoLinkColor' },
    { source: 62, target: 88, value: 1, valueid: 'reph', paperName: 'CSL16', process: 'CSL16_2', id: 'CSL16-16', cluster: 'rtc1', imgUrl: 'mt871Nx.png', color: 'repVisTechColor' },
    {
        source: 150,
        target: 6,
        value: 1,
        valueid: ['targetba', 'repc'],
        paperName: 'MLG06',
        process: 'MLG06_1',
        id: 'MLG06-0',
        cluster: 'rtc1',
        imgUrl: 'qXOBST8.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    { source: 6, target: 39, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-2', cluster: 'rtc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 39, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-6', cluster: 'rtc1', imgUrl: 'qXOBST8.jpg', color: 'intTwoLinkColor' },
    { source: 42, target: 53, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-8', cluster: 'rtc1', imgUrl: 'qXOBST8.jpg', color: 'intThreeLightLinkColor' },
    { source: 53, target: 88, value: 1, valueid: ['targetba', 'repc'], paperName: 'MLG06', process: 'MLG06_1', id: 'MLG06-18', cluster: 'rtc1', imgUrl: 'qXOBST8.jpg', color: 'repVisTechColor' },
    {
        source: 100,
        target: 11,
        value: 1,
        valueid: ['repeb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_3',
        id: 'CAA20-2',
        cluster: 'rtc1',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 100,
        target: 11,
        value: 1,
        valueid: ['repb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_4',
        id: 'CAA20-3',
        cluster: 'rtc1',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 100,
        target: 12,
        value: 1,
        valueid: ['repb', 'targetaa'],
        paperName: 'CAA20',
        process: 'CAA20_5',
        id: 'CAA20-4',
        cluster: 'rtc1',
        imgUrl: 'DFBi3Mo.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-9', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-10', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { source: 12, target: 45, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-11', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { source: 39, target: 59, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-16', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 54, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-17', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 54, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-18', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'intFourLinkColor' },
    { source: 54, target: 92, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_4', id: 'CAA20-26', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    { source: 54, target: 92, value: 1, valueid: ['repb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_5', id: 'CAA20-27', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    { source: 59, target: 92, value: 1, valueid: ['repeb', 'targetaa'], paperName: 'CAA20', process: 'CAA20_3', id: 'CAA20-29', cluster: 'rtc1', imgUrl: 'DFBi3Mo.jpg', color: 'repVisTechColor' },
    {
        source: 105,
        target: 5,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_1',
        id: 'EYG15-0',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 105,
        target: 7,
        value: 1,
        valueid: ['targetca', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_2',
        id: 'EYG15-1',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 105,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-2',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 105,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-3',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 5, target: 49, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-7', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLight2LinkColor' },
    { source: 7, target: 46, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-8', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    { source: 49, target: 63, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-9', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLight2LinkColor' },
    {
        source: 49,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-10',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 46, target: 63, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-11', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'intFiveLinkColor' },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-17',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intTwoLinkColor',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-18',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 39,
        target: 63,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-19',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'intTwoLinkColor',
    },
    { source: 63, target: 92, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_1', id: 'EYG15-21', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'repVisTechColor' },
    { source: 63, target: 92, value: 1, valueid: ['targetca', 'repa'], paperName: 'EYG15', process: 'EYG15_2', id: 'EYG15-22', cluster: 'rtc1', imgUrl: '9p9Vu7Y.jpg', color: 'repVisTechColor' },
    {
        source: 63,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_3',
        id: 'EYG15-23',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 63,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetcb', 'repa'],
        paperName: 'EYG15',
        process: 'EYG15_4',
        id: 'EYG15-24',
        cluster: 'rtc1',
        imgUrl: '9p9Vu7Y.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 110,
        target: 11,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-0',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 110,
        target: 12,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-1',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 34,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-2',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 12,
        target: 34,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-3',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 11,
        target: 36,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-4',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 12,
        target: 36,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-5',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 11,
        target: 40,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-6',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 12,
        target: 40,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-7',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 11,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-8',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 12,
        target: 41,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-9',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-10',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-11',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 34,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-12',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLightLinkColor',
    },
    {
        source: 36,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-13',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 40,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-14',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intTwoLightLinkColor',
    },
    {
        source: 41,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-15',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intThreeLinkColor',
    },
    {
        source: 49,
        target: 60,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-16',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 60,
        target: 92,
        value: 1,
        valueid: ['repf', 'targetbb', 'targetba'],
        paperName: 'HYZ13',
        process: 'HYZ13_1',
        id: 'HYZ13-19',
        cluster: 'rtc1',
        imgUrl: 'TIajUJa.jpg',
        color: 'repVisTechColor',
    },
    {
        source: 113,
        target: 11,
        value: 1,
        valueid: ['targetba', 'targetbb'],
        paperName: 'JX17',
        process: 'JX17_6',
        id: 'JX17-8',
        cluster: 'rtc1',
        imgUrl: 'dbYhmdg.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-18', cluster: 'rtc1', imgUrl: 'dbYhmdg.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 65, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-25', cluster: 'rtc1', imgUrl: 'dbYhmdg.jpg', color: 'intFourLinkColor' },
    { source: 65, target: 92, value: 1, valueid: ['targetba', 'targetbb'], paperName: 'JX17', process: 'JX17_6', id: 'JX17-33', cluster: 'rtc1', imgUrl: 'dbYhmdg.jpg', color: 'repVisTechColor' },
    { source: 116, target: 3, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-2', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'targetLinkColor', status: 'selected' },
    {
        source: 116,
        target: 11,
        value: 1,
        valueid: 'repb',
        paperName: 'LJC18',
        process: 'LJC18_5',
        id: 'LJC18-4',
        cluster: 'rtc1',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 116,
        target: 11,
        value: 1,
        valueid: 'repb',
        paperName: 'LJC18',
        process: 'LJC18_6',
        id: 'LJC18-5',
        cluster: 'rtc1',
        imgUrl: 'bYdgkcY.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 3, target: 45, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-10', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { source: 11, target: 39, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-11', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intTwoLinkColor' },
    { source: 11, target: 45, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-12', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { source: 39, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-20', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-21', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-22', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'intFourLinkColor' },
    { source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_2', id: 'LJC18-35', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_5', id: 'LJC18-36', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    { source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'LJC18', process: 'LJC18_6', id: 'LJC18-37', cluster: 'rtc1', imgUrl: 'bYdgkcY.jpg', color: 'repVisTechColor' },
    {
        source: 117,
        target: 11,
        value: 1,
        valueid: 'targetab',
        paperName: 'LLN14',
        process: 'LLN14_2',
        id: 'LLN14-1',
        cluster: 'rtc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 117,
        target: 15,
        value: 1,
        valueid: 'targetab',
        paperName: 'LLN14',
        process: 'LLN14_2',
        id: 'LLN14-2',
        cluster: 'rtc1',
        imgUrl: 'xWQU5gc.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 34, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_2', id: 'LLN14-11', cluster: 'rtc1', imgUrl: 'xWQU5gc.jpg', color: 'intOneLightLinkColor' },
    { source: 15, target: 34, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_2', id: 'LLN14-12', cluster: 'rtc1', imgUrl: 'xWQU5gc.jpg', color: 'intOneLightLinkColor' },
    { source: 34, target: 55, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_2', id: 'LLN14-13', cluster: 'rtc1', imgUrl: 'xWQU5gc.jpg', color: 'intOneLightLinkColor' },
    { source: 55, target: 92, value: 1, valueid: 'targetab', paperName: 'LLN14', process: 'LLN14_2', id: 'LLN14-16', cluster: 'rtc1', imgUrl: 'xWQU5gc.jpg', color: 'repVisTechColor' },
    {
        source: 119,
        target: 11,
        value: 1,
        valueid: 'targetca',
        paperName: 'MA16',
        process: 'MA16_1',
        id: 'MA16-0',
        cluster: 'rtc1',
        imgUrl: '69BWuDV.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 119,
        target: 16,
        value: 1,
        valueid: 'targetca',
        paperName: 'MA16',
        process: 'MA16_3',
        id: 'MA16-2',
        cluster: 'rtc1',
        imgUrl: '69BWuDV.png',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-6', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'intTwoLinkColor' },
    { source: 16, target: 48, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_3', id: 'MA16-8', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'intFiveLightLinkColor' },
    { source: 39, target: 67, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-12', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'intTwoLinkColor' },
    { source: 48, target: 67, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_3', id: 'MA16-14', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'intFiveLightLinkColor' },
    { source: 67, target: 92, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_1', id: 'MA16-21', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'repVisTechColor' },
    { source: 67, target: 92, value: 1, valueid: 'targetca', paperName: 'MA16', process: 'MA16_3', id: 'MA16-22', cluster: 'rtc1', imgUrl: '69BWuDV.png', color: 'repVisTechColor' },
    {
        source: 129,
        target: 11,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_2',
        id: 'SCS19-2',
        cluster: 'rtc1',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 129,
        target: 16,
        value: 1,
        valueid: 'repa',
        paperName: 'SCS19',
        process: 'SCS19_5',
        id: 'SCS19-5',
        cluster: 'rtc1',
        imgUrl: 'kl0Dozw.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 44,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_2',
        id: 'SCS19-18',
        cluster: 'rtc1',
        imgUrl: 'kl0Dozw.jpg',
        color: 'intThreeLight2LinkColor',
    },
    {
        source: 44,
        target: 63,
        value: 1,
        valueid: ['targetcb', 'repa'],
        paperName: 'SCS19',
        process: 'SCS19_2',
        id: 'SCS19-19',
        cluster: 'rtc1',
        imgUrl: 'kl0Dozw.jpg',
        color: 'intThreeLight2LinkColor',
    },
    { source: 63, target: 92, value: 1, valueid: ['targetcb', 'repa'], paperName: 'SCS19', process: 'SCS19_2', id: 'SCS19-22', cluster: 'rtc1', imgUrl: 'kl0Dozw.jpg', color: 'repVisTechColor' },
    { source: 16, target: 44, value: 1, valueid: 'repa', paperName: 'SCS19', process: 'SCS19_5', id: 'SCS19-29', cluster: 'rtc1', imgUrl: 'kl0Dozw.jpg', color: 'intThreeLight2LinkColor' },
    { source: 44, target: 63, value: 1, valueid: 'repa', paperName: 'SCS19', process: 'SCS19_5', id: 'SCS19-30', cluster: 'rtc1', imgUrl: 'kl0Dozw.jpg', color: 'intThreeLight2LinkColor' },
    { source: 63, target: 92, value: 1, valueid: 'repa', paperName: 'SCS19', process: 'SCS19_5', id: 'SCS19-31', cluster: 'rtc1', imgUrl: 'kl0Dozw.jpg', color: 'repVisTechColor' },
    {
        source: 134,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_1',
        id: 'XWS16-2',
        cluster: 'rtc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 134,
        target: 16,
        value: 1,
        valueid: ['targetab', 'repd'],
        paperName: 'XWS16',
        process: 'XWS16_6',
        id: 'XWS16-5',
        cluster: 'rtc1',
        imgUrl: 'xn5MqwV.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    { source: 11, target: 39, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-8', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intTwoLinkColor' },
    { source: 16, target: 45, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-13', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 39, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-16', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intTwoLinkColor' },
    { source: 45, target: 55, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-21', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'intFourLinkColor' },
    { source: 55, target: 92, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_1', id: 'XWS16-35', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    { source: 55, target: 92, value: 1, valueid: ['targetab', 'repd'], paperName: 'XWS16', process: 'XWS16_6', id: 'XWS16-36', cluster: 'rtc1', imgUrl: 'xn5MqwV.jpg', color: 'repVisTechColor' },
    {
        source: 135,
        target: 11,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_1',
        id: 'YFS10-0',
        cluster: 'rtc1',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 34, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-1', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 11, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-2', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 34, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-3', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-4', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 59, target: 92, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_1', id: 'YFS10-7', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        source: 135,
        target: 12,
        value: 1,
        valueid: ['repea', 'targetbb'],
        paperName: 'YFS10',
        process: 'YFS10_2',
        id: 'YFS10-8',
        cluster: 'rtc1',
        imgUrl: 'A14dGOk.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 34, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-9', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 12, target: 45, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-10', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 34, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-11', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intOneLightLinkColor' },
    { source: 45, target: 59, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-12', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'intFourLinkColor' },
    { source: 59, target: 92, value: 1, valueid: ['repea', 'targetbb'], paperName: 'YFS10', process: 'YFS10_2', id: 'YFS10-15', cluster: 'rtc1', imgUrl: 'A14dGOk.png', color: 'repVisTechColor' },
    {
        source: 143,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-0',
        cluster: 'rtc1',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 14,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-1',
        cluster: 'rtc1',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 143,
        target: 15,
        value: 1,
        valueid: 'targetbb',
        paperName: 'RRR19',
        process: 'RRR19_1',
        id: 'RRR19-2',
        cluster: 'rtc1',
        imgUrl: 'yya8s2u.png',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 12, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-11', cluster: 'rtc1', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 14, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-12', cluster: 'rtc1', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 15, target: 41, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-13', cluster: 'rtc1', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 41, target: 61, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-14', cluster: 'rtc1', imgUrl: 'yya8s2u.png', color: 'intThreeLinkColor' },
    { source: 61, target: 92, value: 1, valueid: 'targetbb', paperName: 'RRR19', process: 'RRR19_1', id: 'RRR19-17', cluster: 'rtc1', imgUrl: 'yya8s2u.png', color: 'repVisTechColor' },
    {
        source: 145,
        target: 12,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_3',
        id: 'MDDD16-4',
        cluster: 'rtc1',
        imgUrl: '4teJby0.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 12,
        target: 37,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_3',
        id: 'MDDD16-9',
        cluster: 'rtc1',
        imgUrl: '4teJby0.jpg',
        color: 'intOneLight3LinkColor',
    },
    {
        source: 37,
        target: 54,
        value: 1,
        valueid: ['targetbb', 'repb'],
        paperName: 'MDDD16',
        process: 'MDDD16_3',
        id: 'MDDD16-14',
        cluster: 'rtc1',
        imgUrl: '4teJby0.jpg',
        color: 'intOneLight3LinkColor',
    },
    { source: 54, target: 92, value: 1, valueid: ['targetbb', 'repb'], paperName: 'MDDD16', process: 'MDDD16_3', id: 'MDDD16-21', cluster: 'rtc1', imgUrl: '4teJby0.jpg', color: 'repVisTechColor' },
    {
        source: 146,
        target: 7,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-0',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-1',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_2',
        id: 'GYS14-2',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 11,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_4',
        id: 'GYS14-4',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 18,
        value: 1,
        valueid: ['targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_6',
        id: 'GYS14-5',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 146,
        target: 18,
        value: 1,
        valueid: 'repb',
        paperName: 'GYS14',
        process: 'GYS14_5',
        id: 'GYS14-7',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 7,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-9',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'intTwoLinkColor',
    },
    {
        source: 11,
        target: 39,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-10',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'intTwoLinkColor',
    },
    { source: 11, target: 45, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-11', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 11, target: 47, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-12', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 18, target: 45, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-14', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 18, target: 47, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-15', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    {
        source: 39,
        target: 54,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-17',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'intTwoLinkColor',
    },
    { source: 45, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-18', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 45, target: 54, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-19', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFourLinkColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-21', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 47, target: 54, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-22', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'intFiveLightLinkColor' },
    { source: 54, target: 92, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_2', id: 'GYS14-39', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    { source: 54, target: 92, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_4', id: 'GYS14-40', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    { source: 54, target: 92, value: 1, valueid: ['targetab', 'repb'], paperName: 'GYS14', process: 'GYS14_6', id: 'GYS14-41', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    {
        source: 54,
        target: 92,
        value: 1,
        valueid: ['targetca', 'targetab', 'repb'],
        paperName: 'GYS14',
        process: 'GYS14_1',
        id: 'GYS14-42',
        cluster: 'rtc1',
        imgUrl: 'r9tEkOr.jpg',
        color: 'repVisTechColor',
    },
    { source: 54, target: 92, value: 1, valueid: 'repb', paperName: 'GYS14', process: 'GYS14_5', id: 'GYS14-43', cluster: 'rtc1', imgUrl: 'r9tEkOr.jpg', color: 'repVisTechColor' },
    {
        source: 153,
        target: 11,
        value: 1,
        valueid: 'repg',
        paperName: 'FZC18',
        process: 'FZC18_3',
        id: 'FZC18-1',
        cluster: 'rtc1',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 153,
        target: 11,
        value: 1,
        valueid: 'repf',
        paperName: 'FZC18',
        process: 'FZC18_1',
        id: 'FZC18-2',
        cluster: 'rtc1',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 153,
        target: 13,
        value: 1,
        valueid: 'repg',
        paperName: 'FZC18',
        process: 'FZC18_3',
        id: 'FZC18-4',
        cluster: 'rtc1',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 153,
        target: 13,
        value: 1,
        valueid: 'repf',
        paperName: 'FZC18',
        process: 'FZC18_1',
        id: 'FZC18-5',
        cluster: 'rtc1',
        imgUrl: 'zz8t6eU.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 11, target: 40, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_3', id: 'FZC18-12', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intTwoLightLinkColor' },
    { source: 13, target: 40, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_3', id: 'FZC18-13', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intTwoLightLinkColor' },
    { source: 40, target: 68, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_3', id: 'FZC18-14', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intTwoLightLinkColor' },
    { source: 68, target: 92, value: 1, valueid: 'repg', paperName: 'FZC18', process: 'FZC18_3', id: 'FZC18-15', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'repVisTechColor' },
    { source: 11, target: 45, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-16', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { source: 13, target: 45, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-18', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    { source: 60, target: 92, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-20', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'repVisTechColor' },
    { source: 45, target: 60, value: 1, valueid: 'repf', paperName: 'FZC18', process: 'FZC18_1', id: 'FZC18-24', cluster: 'rtc1', imgUrl: 'zz8t6eU.jpg', color: 'intFourLinkColor' },
    {
        source: 155,
        target: 7,
        value: 1,
        valueid: ['targetca', 'reph'],
        paperName: 'DJM12',
        process: 'DJM12_1',
        id: 'DJM12-0',
        cluster: 'rtc1',
        imgUrl: 'nNNbNas.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 155,
        target: 9,
        value: 1,
        valueid: ['targetca', 'reph'],
        paperName: 'DJM12',
        process: 'DJM12_5',
        id: 'DJM12-4',
        cluster: 'rtc1',
        imgUrl: 'nNNbNas.jpg',
        color: 'targetLinkOneColor',
        status: 'selected',
    },
    {
        source: 155,
        target: 13,
        value: 1,
        valueid: ['targetca', 'reph'],
        paperName: 'DJM12',
        process: 'DJM12_6',
        id: 'DJM12-5',
        cluster: 'rtc1',
        imgUrl: 'nNNbNas.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 7, target: 34, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_1', id: 'DJM12-9', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLightLinkColor' },
    { source: 9, target: 36, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_5', id: 'DJM12-13', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLight3LinkColor' },
    { source: 13, target: 34, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-14', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLightLinkColor' },
    { source: 34, target: 62, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_1', id: 'DJM12-18', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLightLinkColor' },
    { source: 34, target: 62, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-19', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLightLinkColor' },
    { source: 36, target: 62, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_5', id: 'DJM12-23', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intOneLight3LinkColor' },
    { source: 39, target: 62, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-24', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'intTwoLinkColor' },
    { source: 62, target: 92, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_1', id: 'DJM12-27', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'repVisTechColor' },
    { source: 62, target: 92, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_5', id: 'DJM12-28', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'repVisTechColor' },
    { source: 62, target: 92, value: 1, valueid: ['targetca', 'reph'], paperName: 'DJM12', process: 'DJM12_6', id: 'DJM12-29', cluster: 'rtc1', imgUrl: 'nNNbNas.jpg', color: 'repVisTechColor' },
    {
        source: 157,
        target: 11,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-6',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 12,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-7',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    {
        source: 157,
        target: 16,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-8',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'targetLinkThreeColor',
        status: 'selected',
    },
    {
        source: 11,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-23',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 12,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-24',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 16,
        target: 49,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-25',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    {
        source: 49,
        target: 55,
        value: 1,
        valueid: ['targetaa', 'repd'],
        paperName: 'SFJ16',
        process: 'SFJ16_3',
        id: 'SFJ16-26',
        cluster: 'rtc1',
        imgUrl: 'e3PRKTM.jpg',
        color: 'intFiveLight2LinkColor',
    },
    { source: 55, target: 92, value: 1, valueid: ['targetaa', 'repd'], paperName: 'SFJ16', process: 'SFJ16_3', id: 'SFJ16-28', cluster: 'rtc1', imgUrl: 'e3PRKTM.jpg', color: 'repVisTechColor' },
    {
        source: 158,
        target: 5,
        value: 1,
        valueid: 'targetbb',
        paperName: 'XJX21',
        process: 'XJX21_3',
        id: 'XJX21-5',
        cluster: 'rtc1',
        imgUrl: 'fv9Lvcx.jpg',
        color: 'targetLinkColor',
        status: 'selected',
    },
    {
        source: 158,
        target: 12,
        value: 1,
        valueid: 'targetbb',
        paperName: 'XJX21',
        process: 'XJX21_3',
        id: 'XJX21-6',
        cluster: 'rtc1',
        imgUrl: 'fv9Lvcx.jpg',
        color: 'targetLinkTwoColor',
        status: 'selected',
    },
    { source: 5, target: 39, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-36', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'intTwoLinkColor' },
    { source: 12, target: 39, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-38', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'intTwoLinkColor' },
    { source: 39, target: 69, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-40', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'intTwoLinkColor' },
    { source: 39, target: 71, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-41', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'intTwoLinkColor' },
    { source: 69, target: 92, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-44', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'repVisTechColor' },
    { source: 71, target: 92, value: 1, valueid: 'targetbb', paperName: 'XJX21', process: 'XJX21_3', id: 'XJX21-47', cluster: 'rtc1', imgUrl: 'fv9Lvcx.jpg', color: 'repVisTechColor' },
];
